<div class="control-strip mat-elevation-z2" id="advocateDivId"
     style="width:100%;"
    [ngStyle]="{'background-color': (advocate != null) ? 'var(--blueTheme)' : '' }">

    <div  style="display: inline-block; text-align: left;
    padding-top: 5px;padding-right: 3px;">
        <button mat-button class="command-button" style="scale: 95%" *ngIf="showCaseEdit && (!isHistoryMode || _serviceRequest?.clericalOpen === 1)"
                [disabled] = "_caseId<1 || isEditing ||
                          caseRecord?.caseStatus !== 'Open'"
                (click)="editRecord()" matTooltip="Edit the record"
                mat-button>
            <mat-icon>edit</mat-icon>
            Edit
        </button>

        <button mat-button class="command-button" style="scale: 95%" *ngIf="applyCaseStatus && (!isHistoryMode || _serviceRequest?.clericalOpen === 1)"
                [disabled] = "_caseId<1 || isEditing ||
                          caseRecord?.caseStatus !== 'Open'"
                (click)="doStatus()" matTooltip="Change the status of the case"
                mat-button>
            <mat-icon class="command-icon-style">gavel</mat-icon>
            Status
        </button>
    </div>

    <div *ngIf="advocate != null" style="display: inline-flex; padding-left: 6px;padding-top: 10px">
        <span> Advocate: &nbsp;</span>
        <span style="font-weight: bold;">{{this.returnFullName('d')}}</span>
    </div>

    <div style="float:right; padding-top:5px;padding-right:3px;">
        <button mat-button
                *ngIf="hasClericalOpen && caseRecord?.caseStatus !== 'Open'"
                class="command-button command-button-override"
                style="width:145px"
                matTooltipPosition="below"
                matTooltip="Re-open this case for clerical reasons"
                (click)="doReOpenCase()" mat-button>
            <mat-icon class="command-icon-style">restore</mat-icon>
            Clerical Open
        </button>
        <div *ngIf="fromSource === 'requests' && _serviceRequest?.clericalOpen === 1"
             style="display: inline-flex;
                    align-items: center;
                    background-color: #2dde5e;
                    color: black;
                    padding: 5px 16px;
                    border-radius: 0;
                    font-weight: bold;
                    font-size: 12px;
                    height: 38px;
                    margin-top: -5px;
                    box-sizing: border-box;
                    margin-right: -2px;"
             matTooltip="Note: you are editing a record for this request only - it will not be reflected in other related requests and cases"
             matTooltipPosition="below">
            <mat-icon style="font-size: 15px; height: 15px; width: 15px; margin-right: 6px; line-height: 15px;">history_edu</mat-icon>
            History Edit Mode
        </div>
    </div>
</div>

 <div class="dwform" style="padding-right: 15px;height: 100%;">

	   <div class="dwform-cell-nopadding"
		   style="min-width: 800px;width: 60%;padding-left: 20px"> <!--LHS Fields -->
			<div style="display: inline-block; width: 100%; text-align: right;padding-right: 20px;">
					 
			</div>
			<div class="dwform-row">

                <label class="label-field">Applicant:</label>
                <span class="form-required"></span>
                <span style="font-weight: bold; font-size: 12pt">{{this.returnFullName('a')}}</span>

                <div class="dwform-row-gap"></div>
                <div class="dwform-row-gap-half"></div>
                <div class="dwform-row">

                <label class="label-field">Case Number:</label>
				<span class="form-required">*</span>
				<input class="input-field" id="caseNumber"   [disabled] = "true"
					   style="text-transform: capitalize; width: 110px"
					   [(ngModel)]="caseNumber"
					   placeholder="<Case Number>"
					   type="text">

				<div style="display: inline-block;width: 103px" ></div>
                </div>
			</div>


			<div class="dwform-row-gap-half"></div>

			<div class="dwform-row">
				<label class="label-field">Primary Phone:</label><span class="form-required"></span>

				<input class="input-field" id="phoneNumber"
					   mask="(999) 999-9999" [dropSpecialCharacters]="false"
					   showMaskTyped="true"
					   [(ngModel)]="phoneNumber" [disabled] = "!isEditing"
					   style="width: 110px" type="text" />

                <label class="label-field" style="margin-left: 103px">Email:
                </label><span class="form-required"></span>
                <input class="input-field" id="emailAddress"
                       [(ngModel)]="emailAddress" [disabled] = "!isEditing"
                       placeholder="<Email Address>"
                       type="text" style="width: 250px;">
			</div>
			<div class="dwform-row-gap-half"></div>
		   <div class="dwform-row-gap-half"></div>
			<div class="dwform-row">
					<label class="label-field">Address:</label>
					<span class="form-required"></span>
					<input class="input-field-long" id="address1"
						   [(ngModel)]="address1" [disabled] = "!isEditing"
						   style="text-transform: capitalize"
						   placeholder="<Address line 1>"
						   type="text">
					<input class="input-field-longest" id="address2"
						   [(ngModel)]="address2" [disabled] = "!isEditing"
						   placeholder="<address line 2>"
						   style="text-transform: capitalize;width: 250px; margin-left: 30px"
						   type="text">
			</div>
			<div class="dwform-row-gap-half"></div>
			<div class="dwform-row">
					<label class="label-field">City/St/Zip:</label>
					<span class="form-required"></span>

                <input class="input-field" id="city"
                       style="width: 190px;text-transform: capitalize"
                       onkeydown="return /[a-z, ]/i.test(event.key)"
                       onblur="if (this.value == '') {this.value = '';}"
                       onfocus="if (this.value == '') {this.value = '';}"
                       [(ngModel)]="city"
                       [disabled] = "!isEditing"
                       placeholder="<City>"
                       type="text">

                <input class="input-field-shortest" id="state"
                       maxLength="2"
                       mask="SS"
                       style="width:30px;text-transform: uppercase"
                       [(ngModel)]="state"
                       [disabled] = "!isEditing"
                       placeholder=""
                       type="text">

                <input class="input-field-shortest" id="zipCode"
                       [(ngModel)]="zipCode" style="width: 60px"
                       mask="99999" [dropSpecialCharacters]="false"
                       showMaskTyped="false"
                       [disabled] = "!isEditing"
                       placeholder="<Zip>"
                       type="text">

			</div>
			<div class="dwform-row">
                <div class="dwform-row-gap-half"></div>

					<label class="label-field">Region:</label>
					<span class="form-required"> </span>
					<dw-dropdown [controlWidth]="'190px'"
						[disabled] = "!isEditing"
						[dataSource]="regionsDataSource"
						[selectedItem]="county"
						(itemSelected)="county = $event; ">
					</dw-dropdown>
                <div class="dwform-row-gap-half"></div>
                    <!-- advocate phone number -->
                    <span></span>
                    <label class="label-field">Advocate Phone:</label>
                    <span class="form-required"></span>
                    <input class="input-field" id="advocatePhone"
                           mask="(999) 999-9999" [dropSpecialCharacters]="false"
                           showMaskTyped="true"
                           [(ngModel)]="advocatePhone" [disabled] = "!isEditing"
                           style="width: 110px" type="text" />

                    <!-- Advocate Email -->
                    <span style="margin-left: 102px"></span>
                    <label class="label-field">Advocate email:</label>
                    <span class="form-required"></span>
                    <input class="input-field" id="advocateEmail"
                           [(ngModel)]="advocateEmail" [disabled] = "!isEditing"
                           style="width: 250px" type="text" />

            </div>


			<div class="dwform-row-gap"></div>
		  	<div class="dwform-row" style="display:flex">
		  		
		  		<div class="right-border" style="padding-right:40px;">
			  	    <label  *ngIf="readCurrentNeed" class="label-field label-field-override" style="padding-bottom:3px;vertical-align: top">Current Need:</label>
		            <span class="form-required"> </span>
		            <div style="width: 320px;height: 180px;resize: none;" *ngIf="!readCurrentNeed">
		            
		            </div>
		             <textarea  *ngIf="readCurrentNeed"
                             class="text-area-input"
                             style="width: 320px;height: 180px;resize: none;"  [disabled]="!isEditing || !writeCurrentNeed"
		           [(ngModel)]="currentNeed"></textarea>
	           </div>
	           <div>
	           <table style="margin-left: 20px;">
		           	<tr style="height: 30px; width: 340px;">
		           		<td style="width:140px;">Date Submitted:</td>
		           		<td style="font-weight: bold">{{dateOpened | date:'mediumDate':'EST'}}</td>
		           	</tr>
		           	<tr style="height: 30px; width: 340px;">
		           		<td style="width:140px;">Date Closed:</td>
		           		<td style="font-weight: bold">
                            <span>{{dateClosed | date:'mediumDate':'EST'}}</span></td>
		           	</tr>
		           	<tr style="height: 30px; width: 340px;">
		           		<td style="width:140px;">Case Status:</td>
		           		<td><span [ngStyle]="{'color': getCaseStatusColor()}" style="font-weight: bold">
		           			{{caseStatus}}</span>
							<span *ngIf="caseRecord?.clericalOpen===1"><label style="margin-left: 6px">(Clerically Opened)</label></span>		           		
		           		</td>
		           	</tr>
	           </table>
	           </div>
	        </div>
	  </div>
	  
	  <div class="dwform-cell-nopadding"
		   style="min-width: 150px;width: 40%;padding-left: 20px">
		   <div class="dwform-row-gap-half"></div>
			<div class="dwform-row">

		   </div>
		   
		   <div class="dwform-row-gap"></div>
		   <div class="dwform-row">
				<div class="profile-avatar-container" *ngIf="readCaseAvatar">
						<div #avatarCase id="avatarCase" style="margin-left: 20px;"></div>

						<input #fileInput hidden="true" [disabled]="_serviceRequest?.recordStatus === 0 ||
						        caseRecord?.caseStatus !== 'Open'"
                               type="file" onclick="this.value=null"
                               (change)="fileInputChange($event)"
							   accept="image/*"/>

						<div style="margin-left: 8px; margin-top: 2px;" [hidden]="_serviceRequest?.recordStatus === 0 
						 || caseRecord?.caseStatus !== 'Open'" *ngIf="!readOnlyFlag && writeCaseAvatar">
							<button  style="background: none;" (click)="fileInput.click()" mat-button><mat-icon>camera_alt</mat-icon></button>
							<button  style="background: none;" (click)="clearAvatar($event)" mat-button><mat-icon>cancel</mat-icon></button>
						</div>

						<p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8"  *ngIf="loading"></p-progressSpinner>
				</div>
		   </div>
	 </div>
	  
	<!----------------------->
	<!-- ERROR LINE --------->
	<!----------------------->
	<div class="error-line" [hidden]='!strErr.length'
		 style="text-align:left">{{strErr}}</div>
	<!----------------------->
	<!-- SAVE STRIP        -->
	<!----------------------->
	<div class="save-close-strip" style="bottom: 3px;" *ngIf="isEditing">

		<button mat-button class="command-button"
				(click)="submitRecord()" matTooltip="Save the record"
				mat-button>
			<mat-icon>check_circle_outline</mat-icon>
			Submit
		</button>
		<button mat-button class="command-button"
				(click)="cancelSubmitRecord()" matTooltip="Cancel edits" mat-button>
			<mat-icon>highlight_off</mat-icon>
			Cancel
		</button>
	</div>
</div>

<p-dialog header="Assign a Case Status" [focusOnShow]="false"
          [(visible)]="assignStatusDlg" [modal]="true"
          [style]="{width: '520px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-case-status [caseStatusList]="caseStatusList" #assignStatus
                    [case]="caseRecord"
                    (cancelClicked)="assignStatusDlg=false"
                    (submitClicked)="assignStatusDlg=false;
                    doAssignStatusSubmitted($event)">
    </app-case-status>
</p-dialog>

